export default { 
    data: function() {
        return {
        }
    },
    methods: {
        getThumbImageSrc: function(src) {
            return process.env.VUE_APP_FILE + "320_" + src;
        },
        getThumbImageSrcList: function(res) {
            let imgArray = [];
            if (res) {
                imgArray = res.split(',');
                for (let i = 0; i < imgArray.length; i++) {
                    imgArray[i] = process.env.VUE_APP_FILE + "320_" + imgArray[i];
                }
            }
            return imgArray;
        },
        getImageSrc: function(src) {
            return process.env.VUE_APP_FILE + src;
        },
        getFirstImageSrc: function(src) {
            console.log(src);
            if (src) {
                console.log(process.env.VUE_APP_FILE + "320_" + src.split(",")[0]);
                return process.env.VUE_APP_FILE + "320_" + src.split(",")[0];
            }
        },
        getImageSrcList: function(res) {
            let imgArray = [];
            if (res) {
                imgArray = res.split(',');
                for (let i = 0; i < imgArray.length; i++) {
                    imgArray[i] = process.env.VUE_APP_FILE + imgArray[i];
                }
            }
            return imgArray;
        },
        getImageCount: function(src) {
            let count = 0;
            if (src) {
                count = src.split(",").length;
            }
            return count;
        },
        getImageArray: function(src) {
            let array = 0;
            if (src) {
                array = src.split(",");
            }
            return array;
        }
    }
}